export default "__VITE_ASSET__MOL6HCSM__"